import { useSessionStore } from '@/store/sessionStore'
import styles from './Captions.module.css'

/**
 * What Namu said, when Namu cannot be heard.
 *
 * Only the assistant's words appear here, never the person's. Watching your
 * own speech being transcribed back at you turns a conversation into a
 * dictation exercise, and it is the single thing most likely to make someone
 * start performing for the recogniser instead of talking.
 *
 * The band is hidden by default. It exists for the case where the assistant
 * has no voice at all: no browser ships a Hausa one, and captioning is the
 * difference between an assistant that speaks a language badly and one that
 * simply goes silent in it.
 *
 * Marked `aria-hidden`. Screen readers get the transcript from the single
 * `role="log"` region in LiveRegions, which announces finished turns only.
 */
export function Captions() {
  const turns = useSessionStore((state) => state.turns)

  // Two lines. Enough to hold a question and its follow-up, few enough that
  // the eye is not invited to read rather than listen.
  const recent = turns.filter((turn) => turn.speaker === 'namu').slice(-2)
  if (recent.length === 0) return null

  return (
    <div className={styles.band} data-testid="captions" aria-hidden="true">
      {recent.map((turn) => (
        <p key={turn.id} className={styles.namu}>
          {turn.text}
        </p>
      ))}
    </div>
  )
}
